import { style } from '@vanilla-extract/css';

export const breadcrumbs = style({});

export const breadcrumbsText = style({
  fontSize: 'var(--font-size)',
  lineHeight: 'var(--line-height)',
  '@media': {
    'only screen and (--mobile)': {
      fontSize: 'var(--mobile-font-size)',
      lineHeight: 'var(--mobile-line-height)',
    },
  },
});
